import React, { FC, useState } from 'react'

import { CardWrapper } from '../CardWrapper/CardWrapper'
import { CardItem } from '../CardItem/CardItem'
import { CardEmpty } from '../../empty/CardEmpty/CardEmpty'

import { useProfile } from '../../../../../../hooks/useProfile'

import { IUserInterface } from '../../../../../../models/users/user.interface'

import { disciplineData } from '../../../../../../fakeData/disciplineList'
import { amateurList } from '../../../../../../fakeData/amateurList'
import { zoneList } from '../../../../../../fakeData/ZoneList'
import { JudgingLicence } from '../../../../../../fakeData/judgingLicence'

interface RidingDetailsCardProps {
  user: IUserInterface | null
  setUser?: (state: IUserInterface) => void
  isEditable?: boolean
  isCollapsible?: boolean
}

export const RidingDetailsCard: FC<RidingDetailsCardProps> = ({
  user,
  setUser,
  isCollapsible,
  isEditable,
}) => {
  const { onSaveEditUser, onCancelEditUser, onChangeUserInput } = useProfile()

  const [isEdit, setIsEdit] = useState(false)

  if (!user) return <CardEmpty />

  return (
    <CardWrapper
      isCollapsible={isCollapsible}
      title="Riding Details"
      onSaveEdit={() => onSaveEditUser({ user, setIsEdit })}
      onCancelEdit={() => onCancelEditUser({ user, setUser, setIsEdit })}
      isEditable={isEditable}
      isEdit={isEdit}
      setIsEdit={setIsEdit}
    >
      <CardItem
        label="Discipline"
        isEdit={isEdit}
        fieldType="select"
        fieldKey="userDiscipline"
        defaultValue={
          disciplineData.find((curr) => curr.value === user.userDiscipline)?.label || '-'
        }
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
      <CardItem
        label="Zone"
        isEdit={isEdit}
        fieldType="select"
        fieldKey="userZone"
        defaultValue={zoneList.find((curr) => curr.value === user.userZone)?.label || '-'}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
      <CardItem
        label="Amateur Pro Status"
        isEdit={isEdit}
        fieldType="select"
        fieldKey="userAmateur"
        defaultValue={amateurList.find((curr) => curr.value === user.userAmateur)?.label || '-'}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
      <CardItem
        label="Judging License"
        isEdit={isEdit}
        fieldType="select"
        fieldKey="userJudgingLicense"
        defaultValue={
          JudgingLicence.find((curr) => curr.value === user.userJudgingLicense)?.label ??
          'No license'
        }
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
      <CardItem
        label="Foreign Endorsement Letter"
        fieldType="document"
        fieldKey="userForeignEndorsement"
        defaultValue={user.userForeignEndorsement?.file ? 'View Document' : 'No record found'}
        url={user.userForeignEndorsement?.file}
      />
    </CardWrapper>
  )
}
